import React from "react";
import { connect } from "react-redux";
import { getProfile, editSub } from "../../actions/user";
import { USER_ROLES } from "../../utils/constant";
import { getRole, capitalize } from "../../utils/tools";
import {
  Container,
  Card,
  CardHeader,
  CardFooter,
  CardBody,
  Button,
  FormGroup,
  UncontrolledAlert
} from "reactstrap";
import ReactCrop from "react-image-crop";
import TextEditor from "../../components/Commons/TextEditor";
import SubForm from "../../components/profile/SubForm";
import OverlayLoading from "../../components/Commons/OverlayLoading.jsx";
import moment from "moment";
import { DOMAIN } from "../../utils/constant";

class SubEditPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      article: {
        subscription: {
          businesses: 0,
          classified_ads: 0,
          events: 0,
          lives: 0,
          news: 0,
          southern_plaza: 0,
          tv: 0
        }
      },
      crop: {
        unit: "%",
        width: 30,
        aspect: 16 / 10
      },
      src: null,
      croppedImageUrl: null,
      editable: false
    };

    this.handleCheckBoxChange = this.handleCheckBoxChange.bind(this);
    this.submitArticle = this.submitArticle.bind(this);
  }

  componentDidMount() {
    this.props.getProfile();
  }

  componentWillReceiveProps(newProps) {
    if (newProps.user.selectedUser !== this.props.user.selectedUser) {
      let article = newProps.user.selectedUser;
      if (!article.subscription) {
        article.subscription = {
          businesses: 0,
          classified_ads: 0,
          events: 0,
          lives: 0,
          news: 0,
          southern_plaza: 0,
          tv: 0
        };
      }
      this.setState({
        article: article
      });
    }
  }

  handleCheckBoxChange(e) {
    const { value } = e.target;
    let article = this.state.article;
    article.subscription[value] = !article.subscription[value];
    this.setState({
      article: article
    });
  }

  submitArticle() {
    let { article } = this.state;
    let subscription = article.subscription;
    this.props.editSub({
      subscription
    });
  }

  render() {
    const { crop, croppedImageUrl, src, editable } = this.state;
    let {
      getUserRequest,
      errorMsg,
      errors,
      editUserRequest,
      selectedUser,
      successBackMsg
    } = this.props.user;

    return (
      <Container className="mt-4" fluid>
        <Card className="card-frame">
          <CardHeader className="border-0">
            <div className="d-flex align-items-center justify-content-between">
              <div>
                <h3>訂閱內容</h3>
              </div>
              <div className="d-flex align-items-center"></div>
            </div>
          </CardHeader>
          <OverlayLoading loading={getUserRequest}>
            <CardBody className="row">
              <div className="col-lg-6 px-4">
                {errorMsg && (
                  <UncontrolledAlert color="danger" fade={false}>
                    <span className="alert-inner--text">{errorMsg}</span>
                  </UncontrolledAlert>
                )}
                {successBackMsg && (
                  <UncontrolledAlert color="success" fade={false}>
                    <span className="alert-inner--text mb-4">
                      {successBackMsg}
                    </span>
                  </UncontrolledAlert>
                )}
                <SubForm
                  data={this.state.article.subscription}
                  handleCheckBoxChange={this.handleCheckBoxChange}
                  submitArticle={this.submitArticle}
                  loading={editUserRequest}
                />
                <div className="d-flex align-items-center">
                  <button
                    type="button"
                    className="btn btn-default"
                    disabled={editUserRequest}
                    onClick={this.submitArticle}
                  >
                    保存修改
                  </button>
                </div>
              </div>
            </CardBody>
          </OverlayLoading>
        </Card>
      </Container>
    );
  }
}

const mapStateToProps = state => {
  return {
    user: state.user,
    location: state.router.location,
    pathname: state.router.location.pathname,
    search: state.router.location.search
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getProfile: params => dispatch(getProfile(params)),
    editSub: params => dispatch(editSub(params))
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SubEditPage);
